import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgHadoopMapReduce = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-hadoop-map-reduce';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.187 3.27c-.029.048-4.107 17.349-4.107 17.423 0 .062.236.067 3.218.067h3.218l.035-.13c.019-.072.429-1.88.912-4.02l.877-3.889 1.311-.001c1.499 0 1.393-.03 1.319.377-.038.209-1.738 7.4-1.795 7.593-.019.066.147.07 3.102.07 1.718 0 3.123-.01 3.123-.021s.525-2.293 1.167-5.07l1.167-5.049-.001-.58c-.001-.515-.013-.62-.109-.939-.13-.428-.248-.654-.498-.956a2.5 2.5 0 0 0-1.292-.824c-.281-.078-.402-.081-3.223-.081-1.612 0-2.931-.009-2.931-.021 0-.011.216-.884.48-1.939a75 75 0 0 0 .48-1.979c0-.054-.369-.061-3.218-.061-1.769 0-3.225.014-3.235.03m4.533 1.527c0 .02-.207.87-.459 1.89L10.78 8.63l-.022.09h3.811l3.811.001.2.097c.351.17.502.353.599.725.136.52.14.496-.939 5.171-.55 2.384-1.011 4.377-1.025 4.43l-.024.096h-1.555c-.856 0-1.556-.014-1.556-.032s.316-1.363.703-2.99c.633-2.661.703-2.992.701-3.298q-.007-.944-.62-1.405c-.391-.295-.394-.295-2.683-.295h-2.038l-.906 4-.905 4-1.686.01c-.927.006-1.686.002-1.686-.008s.765-3.26 1.7-7.222c.935-3.961 1.7-7.211 1.7-7.221s.756-.019 1.68-.019c.986 0 1.68.015 1.68.037"
    })
  }));
});
export default SvgHadoopMapReduce;